import React from "react";
import { NavLink } from "react-router-dom";
import { translate } from "../../translations/localization.js";
import { setTab } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { getLocale } from "../../translations/localization.js";
import { useState, useEffect } from "react";
import "./stylesNew.scss";

export default function NavMainDesktopNew() {
  const dispatch = useDispatch();
  const location = window.location.pathname;
  const currentTab = useSelector((state) => state.general.headerTab);
  const [selectedTab, setSelectedTab] = useState("home");

  useEffect(() => {
    if (currentTab) {
      setSelectedTab(currentTab);
      dispatch(setTab(currentTab));
    }
  }, []);

  console.log(location);
  return (
    <div className="nav-main-wrap">
      <nav className="nav-main">
        <div className="items-center">
          <NavLink
            className={`item ${selectedTab === "products" && location !== "/" ? "active" : ""}`}
            to="/Products/home"
            onClick={() => {
              setSelectedTab("products");
              dispatch(setTab("products"));
            }}
          >
            <span>{translate("headerProducts")}</span>
          </NavLink>
          <NavLink
            className={`item ${selectedTab === "references" && location !== "/"  ? "active" : ""}`}
            to="/references"
            onClick={() => {
              setSelectedTab("references");
              dispatch(setTab("references"));
            }}
          >
            <span>{translate("headerReferences")}</span>
          </NavLink>
          <NavLink
            className={`item ${selectedTab === "about" && location !== "/"  ? "active" : ""}`}
            to="/about-us"
            onClick={() => {
              setSelectedTab("about");
              dispatch(setTab("about"));
            }}
          >
            <span>{translate("headerAboutUs")}</span>
          </NavLink>
          <a
            className="item item-catalogue"
            href={getLocale() === "en" ? "/product_catalogue/catalogue-en.pdf" : "/product_catalogue/catalogue-bg.pdf"}
            download
          >
            <span>{translate("headerProductCatalogue")}</span>
          </a>
        </div>
      </nav>
    </div>
  );
}
